import {configureStore as configureStoreToolkit} from "@reduxjs/toolkit";
import rootReducer from "./reducers";
// import loggerMiddleware from "redux-logger";

export const store = configureStoreToolkit({
    reducer: rootReducer,
    // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(loggerMiddleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
